import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  constructor(private firestore: AngularFirestore, private http: HttpClient) {

  }


  public getLocals() {
    return this.http.post(`${environment.query}/locals/getAllLocals/`, null);
  }

  public getKioskos() {
    //return this.http.post(`${environment.query}/locals/getAllKioskos/`, null);
  }

  addPoint(body) {
    //return this.http.post(`${environment.query}/locals/saveLocals/`, body);
  }

  getLocal(body) {
    //return this.http.post(`${environment.query}/locals/getAllLocalsByUserId/`, body);
  }

  getUserProfile(datos) {
    //return this.http.get(`https://us-central1-backservicespagos.cloudfunctions.net/webApi/api/v1/profile/${userId}`);
    return this.http.post(`${environment.query}/locals/getViewsMapas/`, datos);
  }

}
